import React, { useState, useEffect } from "react";
import Fuse from "fuse.js";
import { getUsuarioCursos } from "./service/servicePerfilCursos"; // Ajusta la ruta según corresponda
import useTokenValidation from "../../../../../../../../hooks/useTokenValidation";
import { Oval } from "react-loader-spinner";

export default function PerfilCursos({
  onCardClick,
  filterText,
  selectedCategory,
}) {
  const [cursos, setCursos] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { tokenEntity, resetearToken, errores, notificacionRef } =
    useTokenValidation();

  useEffect(() => {
    if (!tokenEntity.isValidando) {
      const mFetchCursos = () => {
        getUsuarioCursos(tokenEntity.token)
          .then((response) => {
            if (response.ok) {
              return response.json();
            }

            // Manejo de diferentes tipos de errores basados en el código de estado
            switch (response.status) {
              case 400:
                console.log("Datos inválidos en la petición");
                throw new Error("ERR_VALIDATION");

              case 401:
                console.log("Acceso denegado");
                throw new Error("ERR_UNAUTHORIZED");

              case 500:
                console.log("Error al obtener los cursos");
                throw new Error("ERR_SERVER");

              default:
                console.log("Error inesperado");
                throw new Error("ERR_UNKNOWN");
            }
          })
          .then((result) => {
            if (result !== undefined) {
              switch (result["detail"]["acción"]) {
                case "CURSOS_USUARIO_OBTENIDOS":
                  setCursos(result["detail"]["datos"]);
                  break;

                default:
                  break;
              }
            }
          })
          .catch((error) => {
            const { message } = error;
            if (message !== "ERR_ME") {
              console.log("Error de red");
              setError("Error en la conexión con el servidor");
            }
          })
          .finally(() => {
            setLoading(false);
          });
      };

      mFetchCursos();
    }
  }, [tokenEntity.isValidando]);

  if (loading) {
    return (
      <Oval
        visible={true}
        height="50"
        width="50"
        color="#fff"
        secondaryColor="#f5f5f5"
        ariaLabel="oval-loading"
        wrapperStyle={{}}
        wrapperClass=""
      />
    );
  }

  if (error) {
    return <p>Error: {error}</p>;
  }

  // Seleccionar el listado base según la categoría (botón seleccionado)
  const baseList =
    selectedCategory === "TODOS"
      ? cursos.TODOS
      : cursos[selectedCategory] || [];

  // Aseguramos que filterText sea una cadena (para evitar errores con trim())
  const searchTerm = (filterText || "").trim();

  // Aplicar búsqueda difusa solo si hay texto en el input
  let filteredCourses = baseList;
  if (searchTerm !== "") {
    const fuse = new Fuse(baseList, {
      keys: ["nombre_curso"],
      threshold: 0.3,
    });
    const result = fuse.search(searchTerm);
    filteredCourses = result.map((r) => r.item);
  }

  if (filteredCourses.length === 0) {
    return (
      <div data-figma-id="2469:46068" class="alerta-no-encontrar">
        <p
          data-figma-id="2469:45979"
          class="alerta-no-encontrar-cursos-texto-1 "
        >
          Lo sentimos, no hemos encontrado resultados para “Curso {searchTerm}”
        </p>
        <div data-figma-id="2469:45980" class="frame-290009">
          <img
            class="file-1"
            src="../images/file-1.svg"
            data-figma-image-id="67f5c2d60b3f2b1fa6a0ffe5"
            alt=""
            data-figma-id="2469:46028"
            data-figma-image-hash="c657b7acce0455d1878dee5ea8f79879"
            loading="lazy"
          />
          <div
            data-figma-id="2469:45982"
            class="alerta-no-encontrar-cursos-contenido"
          >
            <p
              data-figma-id="2469:45983"
              class="alerta-no-encontrar-cursos-contenido-texto"
            >
              No existe en esta Plataforma, modifica tu búsqueda o prueba lo
              siguiente:
            </p>
            <div
              data-figma-id="2469:45984"
              class="alerta-no-encontrar-cursos-contenido-info"
            >
              <div
                data-figma-id="2469:45985"
                class="alerta-no-encontrar-cursos-info-1"
              >
                <div data-figma-id="2469:46064" class="circulito-gris-claro">
                  <img
                    src="../images/Vector_3.svg"
                    data-figma-image-id="67f5c2d8405281f91e4dba11"
                    alt=""
                    data-figma-id="2469:46065"
                    data-figma-image-hash="cb50c9aa61f5c3c0ef583559b56541b2"
                    loading="lazy"
                  />
                </div>
                <p
                  data-figma-id="2469:45987"
                  class="alerta-no-encontrar-cursos-info-1-texto"
                >
                  Asegúrate de que todas las palabras están escritas
                  correctamente
                </p>
              </div>
              <div
                data-figma-id="2469:45988"
                class="alerta-no-encontrar-cursos-info-2"
              >
                <div data-figma-id="2469:46066" class="circulito-gris-claro">
                  <img
                    src="../images/Vector_3.svg"
                    data-figma-image-id="67f5c2d8405281f91e4dba11"
                    alt=""
                    data-figma-id="2469:46067"
                    data-figma-image-hash="cb50c9aa61f5c3c0ef583559b56541b2"
                    loading="lazy"
                  />
                </div>
                <p
                  data-figma-id="2469:45990"
                  class="alerta-no-encontrar-cursos-info-2-texto"
                >
                  Prueba con términos de búsqueda diferente
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // Función auxiliar para determinar el icono según el estado del curso
  const getIconClass = (estado) => {
    const estadoNormalized = estado.toLowerCase();
    if (estadoNormalized === "en curso") return "fi fi-rs-pencil";
    if (estadoNormalized === "certificado") return "fi fi-rs-diploma";
    if (estadoNormalized === "inconcluso") return "fi fi-bs-ban";
    return "fi fi-rs-pencil"; // Valor por defecto
  };

  return (
    <div data-figma-id="1620:14320" className="perfil-tarjetas-cursos">
      {filteredCourses.map((curso) => (
        <div
          key={curso.curso_id}
          data-figma-id="1623:15358"
          className="tarjeta-curso-perfil"
          onClick={() => onCardClick(curso.curso_id)}
        >
          <div
            data-figma-id="1623:15359"
            className="tarjeta-curso-perfil-titulos"
          >
            <p
              data-figma-id="1623:15360"
              className="tarjeta-curso-perfil-titulo-1 truncate-2-line"
            >
              {curso.nombre_curso}
            </p>
            <p
              data-figma-id="1623:15361"
              className="tarjeta-curso-perfil-titulo-2"
            >
              por {curso.nombre_profesor}
            </p>
          </div>
          <div data-figma-id="1623:15362" className="tarjeta-curso-perfil-info">
            <div
              data-figma-id="1623:15363"
              className="tarjeta-curso-perfil-promedio"
            >
              {/* Tarjeta de progreso 
              <p
                data-figma-id="1623:15364"
                className="tarjeta-curso-perfil-promedio-texto-2"
              >
                {curso.calificacion}
              </p>
              <p
                data-figma-id="1623:15365"
                className="tarjeta-curso-perfil-promedio-texto-3"
              >
                promedio
              </p>
                */}
            </div>
            <div data-figma-id="1623:15371" className="filtro-en-curso-boton">
              <i className={`${getIconClass(curso.estado)} component-6`}></i>
              <p
                data-figma-id="1623:15373"
                className="filtro-en-curso-boton-texto"
              >
                {curso.estado}
              </p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
